module.exports = __webpack_public_path__ + "static/media/work.ce66940e.svg";